export default "__VITE_ASSET__HfMyMZfe__"